import type { SpeechRecognitionService } from "./types";

const speechRecognition: SpeechRecognitionService = {
  isSupported: () => false,
  isAvailable: () => false,
  requestPermissions: async () => ({ granted: false }),
  start: () => {},
  stop: () => {},
  subscribe: () => () => {},
};

export default speechRecognition;
